import { Box, Button, Dialog, Typography, Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";

// 기본 다이얼로그 컨테이너
export const BaseDialogBox = styled(Dialog)(({ theme }) => ({
  "& .MuiBackdrop-root": {
    background: "rgba(0, 0, 0, 0.8)",
  },
  "& .MuiPaper-root": {
    minWidth: 328,
    background: "#fff",
    padding: "32px 24px",
    boxSizing: "border-box",
    borderRadius: 16,
    gap: 24,
  },
}));

// Drawer 스타일 다이얼로그
export const BaseDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: "32px 24px",
    gap: 24,
  },
}));

// 다이얼로그 제목
export const DialogTitle = styled(Typography)(({ theme }) => ({
  "&.MuiTypography-root": {
    fontSize: "1.125rem",
    color: "#333",
    fontWeight: 700,
    lineHeight: "25.2px",
    textAlign: "center",
  },
}));

// 다이얼로그 내용 텍스트
export const DialogContent = styled(Typography)(({ theme, color }) => ({
  fontSize: "0.875rem",
  color: color ? color : "#333",
  textAlign: "center",
  whiteSpace: "pre-line",
}));

// 액션 버튼 컨테이너
export const ActionBox = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

// 기본 버튼 스타일
export const BaseButton = styled(Button)(({ theme }) => ({
  "&.MuiButtonBase-root": {
    minWidth: 136,
    padding: 16,
    borderRadius: 8,
    boxSizing: "border-box",
    color: "#333",
    "& p": {
      fontSize: "0.875rem",
      color: "#333",
      lineHeight: "19.6px",
      fontWeight: 400,
    },
  },
}));

// 취소 버튼 (왼쪽)
export const CancelButton = styled(BaseButton)(({ theme }) => ({
  "&.MuiButtonBase-root": {
    background: "#fff",
    outline: "1px solid #C9C9CA",
    marginRight: 8,
    "&:hover": {
      background: "#fff",
    },
  },
}));

// 확인 버튼 (오른쪽)
export const ConfirmButton = styled(BaseButton)(({ theme }) => ({
  "&.MuiButtonBase-root": {
    background: "#FDD751",
    "&.delete-dialog": {
      background: "#FE536B",
      color: "#fff",
      "& p": {
        color: "#fff",
      },
    },
    "&:hover": {
      background: "#FDD751",
    },
  },
}));

// 단일 액션 버튼 (전체 너비)
export const SingleActionButton = styled(BaseButton)(({ theme }) => ({
  "&.MuiButtonBase-root": {
    width: "100%",
    background: "#FDD751",
    "&:hover": {
      background: "#FDD751",
    },
    "&.Mui-disabled": {
      background: "#C9C9CA",
      color: "#fff",
    },
  },
}));
